/**
 * Сокращает строку до указанной длины и добавляет многоточие
 * @param {string} str - Исходная строка
 * @param {number} maxLength - Максимальная длина (по умолчанию 15)
 * @returns {string} Сокращенная строка
 */
export function cutString(str, maxLength = 15) {
    if (!str || str.length <= maxLength) {
        return str;
    }
    return str.slice(0, maxLength) + '...';
}